import { render, staticRenderFns } from "./RedtailAppDetails.vue?vue&type=template&id=0aa3fccf&"
import script from "./RedtailAppDetails.vue?vue&type=script&setup=true&lang=js&"
export * from "./RedtailAppDetails.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports